<div class="h-screen overflow-auto lg:px-16 py-8 bg-white grid md:grid-cols-2">
  <!-- left side - EXACTLY SAME AS LOGIN -->
  <div class="relative hidden md:flex flex-col rounded-tl-3xl overflow-hidden">
    <img
      [src]="slides[currentIndex]?.image"
      alt="Feature Image"
      class="absolute top-0 left-0 z-0 w-full h-full object-cover transition-all duration-700 ease-in-out"
    />

    <div
      class="absolute z-10 top-0 left-0 w-full h-full bg-gradient-to-b from-black/10 via-black/50 to-black/75"
    ></div>

    <div class="relative z-20 w-full grid grid-cols-2">
      <div class="rounded-tl-3xl relative">
        <div class="absolute top-0 right-0 notched-top-right"></div>
      </div>
      <div class="rounded-bl-3xl bg-white flex pl-3">
        <p
          class="text-primary text-sm font-medium hidden lg:flex items-center justify-center gap-2 rounded-full border border-primary ml-4 w-[96%] px-4 py-4 mx-auto"
        >
          <i class="fas fa-newspaper text-[#1A4A9C]"></i>
          <span>Digital Publishing Management System</span>
        </p>
      </div>
    </div>
    <div class="relative z-20 flex-1 col-span-full w-full flex flex-col px-16">
      <div class="absolute top-0 right-0 notched-top-right"></div>

      <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>

      <div class="flex flex-col mt-auto mb-[2%]">
        <div
          class="text-2xl font-sans text-white mt-auto py-8 text-left w-[60%]"
        >
          {{ slides[currentIndex]?.text }}
        </div>
        <!-- Features List -->
        <div class="space-y-2 mb-6">
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Manage newspapers & magazines</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Digital book library system</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Real-time publishing tools</span>
          </div>
        </div>
      </div>
    </div>

    <!-- lower action buttons -->
    <div class="w-full flex relative z-20">
      <div class="absolute top-0 left-0 notched-top-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
      <div class="absolute top-0 right-0 notched-top-right"></div>
      <div class="rounded-tr-3xl pt-3 pb-2 pr-3 bg-white">
        <button
          (click)="prev()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="flex-1 h-full relative flex justify-center">
        <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
        <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
        <div class="flex space-x-3 mt-8">
          <div
            *ngFor="let slide of slides; let i = index"
            class="cursor-pointer transition-all duration-300 rounded-full !h-3"
            [ngClass]="{
              'w-8 bg-primary-200 ': i === currentIndex,
              'w-3 bg-white hover:bg-white/80': i !== currentIndex
            }"
          ></div>
        </div>
      </div>
      <div class="rounded-tl-3xl pt-3 pb-2 pl-3 bg-white">
        <button
          (click)="next()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- right-side - SAME STRUCTURE, ONLY FORM CONTENT CHANGED -->
  <div class="relative overflow-hidden lg:mr-16">
    <!-- Floating Icons for ePaper Theme (same as login) -->
    <div
      class="absolute top-36 left-20 text-[#03406C]/10 text-3xl animate-float"
    >
      <i class="fas fa-newspaper"></i>
    </div>
    <div
      class="absolute top-40 right-32 text-[#03406C]/10 text-3xl animate-float-delayed"
    >
      <i class="fas fa-book-open"></i>
    </div>
    <div
      class="absolute bottom-32 left-40 text-[#03406C]/10 text-4xl animate-float"
    >
      <i class="fas fa-scroll"></i>
    </div>
    <div
      class="absolute bottom-20 right-20 text-[#03406C]/10 text-3xl animate-float-delayed"
    >
      <i class="fas fa-feather-alt"></i>
    </div>

    <!-- Main Content Container -->
    <div class="relative z-20 flex flex-col justify-center items-center h-full lg:ml-16">
      <!-- Logo & Emblem Section (same as login) -->
      <div class="flex justify-center items-center gap-4 animate-fadeIn w-full">
        <img src="assets/images/tsn.png" class="w-16 h-16" alt="tsn Emblem" />
      </div>

      <!-- Forgot Password Form -->
   <form
  [formGroup]="form"
  (ngSubmit)="sendResetEmail()"
  autocomplete="off"
  novalidate
  class="w-full animate-slideUp"
>
  <div class="max-w-lg mx-auto backdrop-blur-md p-8">

    <!-- Title -->
    <div class="mb-6 text-center">
      <h2 class="!text-4xl !font-semibold text-[#1A4A9C] mb-1">
        Forgot Password?
      </h2>
      <p class="text-lg text-gray-500">
        Don’t worry, we’ll send you reset instructions
      </p>
    </div>

    <!-- Email Input -->
    <div class="mb-5">
      <label class="block text-sm font-semibold text-gray-700 mb-2 ml-1">
        <i class="fas fa-envelope text-[#1A4A9C] mr-2"></i>Email Address
      </label>

      <div class="relative">
        <input
          type="email"
          formControlName="email"
          placeholder="Enter your email"
          class="w-full h-16 rounded-2xl border-2 border-gray-200 px-5 pl-12
                 focus:outline-none focus:border-[#1A4A9C]
                 focus:ring-2 focus:ring-blue-100 transition-all bg-white"
        />
        <i
          class="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
        ></i>
      </div>

      <!-- Validation Error -->
      <p
        *ngIf="form.controls['email'].touched && form.controls['email'].invalid"
        class="text-red-500 text-sm mt-1"
      >
        Please enter a valid email address
      </p>
    </div>

    <!-- Submit Button -->
    <button
      type="submit"
      [disabled]="form.invalid || loading"
      class="w-full h-14 rounded-2xl text-white font-bold text-lg
             bg-gradient-to-r from-[#124B99] via-[#03406C] to-[#509EE3]
             shadow-lg hover:shadow-xl hover:scale-[1.02]
             transition-all duration-300
             disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span *ngIf="!loading">Send Email</span>
      <span *ngIf="loading">
        <i class="fas fa-spinner fa-spin mr-2"></i>Sending...
      </span>
    </button>

    <!-- Back to Login -->
    <div class="mt-6 text-center">
      <a
        routerLink="/login"
        class="text-sm text-[#124B99] font-semibold hover:text-[#509EE3]"
      >
        ← Back to Sign In
      </a>
    </div>
  </div>
</form>


      <!-- Footer (same as login) -->
      <div class="mt-8 text-center space-y-4">
        <p class="text-sm text-gray-600 font-medium">
          © 2025 RIDC - Research and Innovation Development Center
        </p>

        <div class="flex gap-3 justify-center">
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-[#1A4A9C] hover:border-[#1A4A9C] hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-instagram text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-400 hover:border-blue-400 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-twitter text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-facebook-f text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-red-600 hover:border-red-600 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-youtube text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>